import { Component, OnDestroy, OnInit} from '@angular/core';
import { VpoName } from '../../../models/vpo.model';
import { select, Store } from '@ngrx/store';
import * as fromRoot from '../../../store/reducers';
import { getSelected } from '../../../store/reducers/vpo';

@Component({
    selector: 'app-site-footer',
    templateUrl: './site-footer.component.html',
    styleUrls: ['./site-footer.component.scss']
})
export class SiteFooterComponent implements OnInit, OnDestroy {

  private subscriber: any;
  selectedVpo: VpoName;
  currentYear: number;

  constructor(private store: Store<fromRoot.AppState>) { }

  ngOnInit() {
    // get list of news
    this.subscriber = this.store
      .pipe(
        select(fromRoot.selectVpoState())
      )
      .subscribe((state: any) => {
        this.selectedVpo = getSelected(state);
      });

    // set year
    this.currentYear = new Date().getFullYear();
  }

  ngOnDestroy() {
    this.subscriber.unsubscribe();
  }

}
